// extracted by mini-css-extract-plugin
export default {"overflowMenu":"OverflowMenu_overflowMenu__lyX+3","overflowIcon":"OverflowMenu_overflowIcon__5P6ol","optionCon":"OverflowMenu_optionCon__mTmgp"};